import { Notice } from '../components/ui/notice';
import { useI18n } from '../i18n/i18n';
import { useCurrentWorkspace } from './current-workspace';

/** Архивное пространство открыто только на чтение (ADR-0014) — говорим об этом сразу. */
export function ArchivedNotice() {
  const { t } = useI18n();
  const workspace = useCurrentWorkspace();
  if (!workspace.archived) return null;
  return <Notice>{t('workspace.archivedNotice')}</Notice>;
}
